import { useEffect, useRef } from "react";
import { useRouterState } from "@tanstack/react-router";
import { smoothScrollToTop } from "@project/lib/scroll-to-top";

/** Smooth scroll to top whenever the user navigates to a new page. */
export function ScrollToTop() {
  const locationKey = useRouterState({
    select: s => `${s.location.pathname}${s.location.searchStr}`,
  });
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    smoothScrollToTop();
  }, [locationKey]);

  return null;
}
